import React, { Component } from "react";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

class CookieModal extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const { cookies } = props;
    this.state = {
      showOptions: false,
      isCookiesSet:
        cookies.get("allowCookiesGA") || cookies.get("allowCookiesFB") || false,
      cookieGA: cookies.get("allowCookiesGA") || false,
      cookieFB: cookies.get("allowCookiesFB") || false,
      checkBoxFB: true,
      checkBoxGA: true,
    };

    this.handleChangeFB = this.handleChangeFB.bind(this);
    this.handleChangeGA = this.handleChangeGA.bind(this);
    this.handleClickChangeOptions = this.handleClickChangeOptions.bind(this);
  }

  componentDidMount() {
    this.initializeCookies();
  }

  handleClickAccept() {
    const { cookies } = this.props;
    const { checkBoxGA, checkBoxFB } = this.state;

    var expiration = new Date();

    expiration.setDate(expiration.getDate() + 90);

    checkBoxFB &&
      cookies.set("allowCookiesFB", checkBoxFB, {
        path: "/",
        expires: expiration,
      });
    checkBoxGA &&
      cookies.set("allowCookiesGA", checkBoxGA, {
        path: "/",
        expires: expiration,
      });
    this.setState(
      {
        isCookiesSet: true,
      },
      () => this.initializeCookies()
    );
  }

  handleClickChangeOptions() {
    this.setState((prevState) => ({
      showOptions: !prevState.showOptions,
    }));
  }

  handleChangeFB() {
    this.setState((prevState) => ({
      checkBoxFB: !prevState.checkBoxFB,
    }));
  }

  handleChangeGA() {
    this.setState((prevState) => ({
      checkBoxGA: !prevState.checkBoxGA,
    }));
  }

  initializeCookies() {
    const { cookies } = this.props;
    const { checkBoxGA, checkBoxFB } = this.state;

    if (cookies.get("allowCookiesGA")) {
//LIVE LEELO
     ReactGA.initialize("UA-5061824-8", {
        debug: false,
      });
      
     //TEST LEELO
     /* ReactGA.initialize("UA-5061824-7", {
        debug: false,
      });
*/
      //LIVE
      /*ReactGA.initialize("UA-5061824-1", {
        debug: false,
      }); 
       */
       //TEST
        /*
       ReactGA.initialize("UA-73464228-1", {
        debug: false,
      }); */
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
    if (cookies.get("allowCookiesFB")) {
      const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
      };

     ReactPixel.init("215818349457156", options);
      ReactPixel.pageView();
    }
    // For tracking page view
  }

  render() {
    const { language } = this.props;
    const { isCookiesSet, showOptions } = this.state;

    return (
      <>
        {!isCookiesSet ? (
          <div className={`cookieModal`}>
            <div className="modal__inner">
              <div className="modal__inner__top">
                <p className="smaller">
                  <strong>
                    {language === "et"
                      ? `Nõusolek isikuandmete töötlemiseks ja küpsiste kasutamiseks`
                      : `Согласие на обработку личных данных и использование файлов cookie`}
                  </strong>
                </p>
                <p>
                  {language === "et"
                    ? `Kampaanialehe kasutajate isikuandmete töötlemiseks ja
                  küpsistega nõustumiseks valige palun „Nõustun“. Nõusolek
                  hõlmab kolmandate osapoolte teenuste kasutamist, sh Google
                  Analytics’i küpsist veebilehe kasutuse statistika
                  analüüsimiseks ning Facebooki küpsiste ja Facebook Pixel koodi
                  kasutust, mille abil näete just teile kohaldatud reklaame.
                  Teil on võimalik oma valikut täpsustada või neist teenustest
                  loobuda valides „Muudan seadeid“.`
                    : `Для соглашения с обработкой персональных данных пользователей страницы кампаний и с использованием файлов cookie, пожалуйста, нажмите кнопку «Согласиться». Согласие включает в себя использование сторонних сервисов, в том числе cookie-файл Google Analytics для анализа статистики использования веб-сайта, а также использование cookie-файлов Facebook и пиксельного кода Facebook для просмотра специально для вас размещённой рекламы. Вы можете уточнить свой выбор или отказаться от этих услуг, выбрав «Изменить настройки».`}
                </p>
                <div>
                  <a
                    href={`https://www.eestiloto.ee/osi/customer/privacy${
                      language === "ru" ? "?language=ru" : ""
                    }`}
                    target="_blank"
                  >
                    {language === "et"
                      ? `Eesti Loto isikuandmete töötlemise põhimõtetest lähemalt`
                      : `Подробнее о Принципах обработки личных данных в Eesti Loto`}
                  </a>
                </div>
              </div>
              {showOptions ? (
                <div className="hidden__area">
                  <div className="block">
                    <p>
                      {language === "et"
                        ? `  Google Analytics’i küpsiste kasutamine veebilehe kasutuse
                      statistika analüüsimiseks.`
                        : `Использование cookie-файлов Google Analytics для анализа статистики использования сайта`}
                    </p>
                    <div>
                      <a
                        href="https://policies.google.com/privacy"
                        target="_blank"
                      >
                        {language === "et"
                          ? `  Lähemalt, kuidas Google teie andmeid töötleb`
                          : `Подробнее о том, как Google обрабатывает ваши данные`}
                      </a>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        id="ga"
                        onChange={() => this.handleChangeGA()}
                        checked={this.state.checkBoxGA}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                  <div className="block">
                    <p>
                      {language === "et"
                        ? `  Facebook’i küpsiste ja Facebook Pixel koodi kasutamine
                      reklaamide kohaldamiseks.`
                        : `Использование cookie-файлов Facebook и кода Facebook Pixel для размещения рекламы`}
                    </p>
                    <div>
                      <a
                        href="https://www.facebook.com/about/privacy/"
                        target="_blank"
                      >
                        {language === "et"
                          ? `    Lähemalt, kuidas Facebook teie andmeid töötleb`
                          : `Подробнее о том, как Facebook обрабатывает ваши данные`}
                      </a>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        id="fb"
                        onChange={() => this.handleChangeFB()}
                        checked={this.state.checkBoxFB}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="button--wrap text-center">
                <button
                  className="button button--primary"
                  onClick={() => this.handleClickAccept()}
                >
                  {language === "et" ? ` Nõustun` : `Согласиться`}
                </button>
                <button
                  className="button button--disagree"
                  onClick={() => this.handleClickChangeOptions()}
                >
                  {language === "et"
                    ? `  Muudan seadeid`
                    : `Изменить настройки`}
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default withCookies(CookieModal);
